
import config from "../../config/config";
import axios from "axios";
import { toast } from 'react-toastify';
import { getAuthToken } from "../../utils/token";
import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Loader from "../loader/Loader";

const MaterialInspectionReporModal = ({ show, handleClose, materialId,refreshParent }) => {
    const [verifymaterial, setVerifymaterial] = useState([])
    const [loading, setLoading] = useState(false)
    const [inspectionChecklist, setInspectionChecklist] = useState({
        visual_inspection: false,
        dimensional_check: false,
        quantity_check: false,
        packaging_condition: false,
        material_certificate: false,
    });

    const [notes, setNotes] = useState("");
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setInspectionChecklist((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };
    /* ================= APPROVE API ================= */
    const handleApprove = async () => {
        const token = getAuthToken();
        if (!token) return;

        try {
            const payload = {
                material_information: {
                    material_id: verifymaterial?.material_id,
                    material_name: verifymaterial?.material_master?.material_name,
                    expected_quantity: verifymaterial?.material_master?.quantity_in_stock,
                    unit: verifymaterial?.material_master?.unit_of_measurement,
                },
                inspection_report: {
                    inspection_checklist: inspectionChecklist,
                    notes: notes,
                },
            };
            const response = await axios.post(
                `${config.API}/manager/updateverifymaterial/${materialId}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            toast.success(response?.data?.message || "Material approved successfully");
            setInspectionChecklist("");
            setNotes("")
            await refreshParent()
            handleClose();
        } catch (error) {
            toast.error("Approval failed");
            console.error(error);
        }
    };

    const fetchVerifymaterialDetails = async () => {
        const token = getAuthToken();
        if (!token) return;
        try {
            setLoading(true);
            const response = await axios.get(`${config.API}/manager/verifymaterial/${materialId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = response?.data;
            if (data.success === true) {
                setVerifymaterial(data?.material)

            } else {
                setVerifymaterial([]);
            }

        } catch (err) {
            console.error("Error fetching operators:", err.message);
            setVerifymaterial([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (show && materialId) {
            fetchVerifymaterialDetails();
        }
    }, [show, materialId]);

    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className="font_family">
           {
            loading ?(
                <Loader/>
            ):(
                 <Modal.Body className="p-5">
                <h4 className="mb-4 fw-bold">Material Inspection Report</h4>

                {/* Material Information */}
                <div className="p-3 border rounded bg-light mb-4">
                    <h6 className="fw-semibold">Material Information</h6>
                    <Row className="mt-2">
                        <Col md={6}><strong>ID:</strong> {verifymaterial?.material_master?.material_code}</Col>
                        <Col md={6}><strong>Material:</strong> {verifymaterial?.material_master?.material_name}</Col>
                    </Row>
                    <Row>
                        <Col md={6}><strong>Expected Qty:</strong> {verifymaterial?.material_master?.quantity_in_stock} {verifymaterial?.material_master?.unit_of_measurement}</Col>
                        <Col md={6}><strong>Supplier:</strong> {verifymaterial?.supplier_name}</Col>
                    </Row>
                </div>

                {/* NC Report */}
                <div className="p-3 border rounded bg-light mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <Button size="sm" variant="outline-secondary">View Full Report</Button>
                    </div>

                    {/* Inspection Checklist */}
                    <h6 className="fw-semibold mb-2">Inspection Checklist</h6>
                    <Form>
                        <Form.Check
                            label="Visual Inspection (No visible defects)"
                            name="visual_inspection"
                            checked={inspectionChecklist.visual_inspection}
                            onChange={handleCheckboxChange}
                        />
                        <Form.Check
                            label="Dimensional Check (Meets specifications)"
                            name="dimensional_check"
                            checked={inspectionChecklist.dimensional_check}
                            onChange={handleCheckboxChange}
                        />
                        <Form.Check
                            label="Quantity Check (Matches delivery note)"
                            name="quantity_check"
                            checked={inspectionChecklist.quantity_check}
                            onChange={handleCheckboxChange}
                        />
                        <Form.Check
                            label="Packaging Condition (No damage)"
                            name="packaging_condition"
                            checked={inspectionChecklist.packaging_condition}
                            onChange={handleCheckboxChange}
                        />
                        <Form.Check
                            label="Material Certificate (Provided and valid)"
                            name="material_certificate"
                            checked={inspectionChecklist.material_certificate}
                            onChange={handleCheckboxChange}
                        />
                    </Form>
                </div>

                <Row>
                    <Col md={2}></Col>
                    <Col md={10}>
                        <Form.Group className="mt-4">
                            <Row>
                                <Col md={2}>
                                    <Form.Label>Notes</Form.Label>
                                </Col>
                                <Col md={10}>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={notes}
                                        onChange={(e) => setNotes(e.target.value)}
                                        placeholder="Additional notes or observations"
                                    />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Col>
                </Row>
            </Modal.Body>
            )
           }

            <Modal.Footer className="border-0">
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="dark" onClick={handleApprove}>
                    Approve
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MaterialInspectionReporModal;
